<template>
    <div class="layout-topbar">
        <router-link :to="{ name: 'dashboard-panel' }" class="layout-topbar-logo">
            <img alt="Logo" src="/images/contablus.png" />
        </router-link>

        <!-- Botón para el menú lateral (igual que antes) -->
        <button
            class="p-link layout-menu-button layout-topbar-button"
            @click="onMenuToggle"
            aria-label="Abrir menú lateral"
        >
            <i class="pi pi-bars"></i>
        </button>

        <!-- Centro de notificaciones (campanita + historial de broadcasts) -->
        <NotificationCenter class="topbar-notif" />

        <!-- Botón existente (tres puntos). Ahora abre el panel del AccountSwitcher -->
        <button
            class="p-link layout-topbar-menu-button layout-topbar-button"
            @click="openAccountMenu"
            aria-haspopup="true"
            :aria-expanded="String(panelVisible)"
            aria-label="Abrir menú de cuentas"
        >
			<ActivityLogo :activity="$store.getters.defaultActivity" alt="Cuenta actual" imgClass="circle-logo" fill />
        </button>

        <!-- AccountSwitcher de escritorio -->
        <AccountSwitcher
            ref="accountSwitcher"
            class="hidden lg:flex"
            style="margin-left: 0.5rem;"
            @logout="logout"
        />
    </div>
</template>

<script>
import httpRequest from './service/httpRequest';
import AccountSwitcher from './components/General/AccountSwitcher.vue';
import ActivityLogo from './components/General/ActivityLogo.vue';
import NotificationCenter from './components/NotificationCenter/NotificationCenter.vue';

export default {
    components: {
        AccountSwitcher,
        ActivityLogo,
        NotificationCenter
    },
    data() {
        return {
            // usado solo para aria-expanded del botón de tres puntos
            panelVisible: false
        };
    },
    methods: {
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
        onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
        topbarImage() {
            return this.$appState.darkTheme ? 'images/logo-white.svg' : 'images/logo-dark.svg';
        },
        async logout() {
            const response = await httpRequest.logout();
            if (response.status) {
                await this.$store.dispatch('Logout');
                this.$router.push('/login');
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Hemos tenido un problema al cerrar su sesión',
                    life: 5000
                });
            }
        },
        // Abre el OverlayPanel del AccountSwitcher reutilizando el botón existente
        openAccountMenu(event) {
            const sw = this.$refs.accountSwitcher;
            if (sw && typeof sw.toggle === 'function') {
                sw.toggle(event);
                // Si luego quieres aria-expanded en tiempo real, haz que AccountSwitcher emita @panel-show/@panel-hide
                this.panelVisible = true;
                // (opcional) escucha eventos desde AccountSwitcher para sincronizar:
                // <AccountSwitcher @panel-show="panelVisible=true" @panel-hide="panelVisible=false" />
            }
        }
    },
    computed: {
        darkTheme() {
            return this.$appState.darkTheme;
        }
    }
};
</script>


<style scoped>
/* Botón circular móvil */
.account-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--surface-card);
    border: 1px solid var(--surface-border);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}


.circle-logo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 1px 4px #c1cbdc;
}

/* Campanita: empujada a la derecha en escritorio; dentro de la fila (orden) en móvil. */
.topbar-notif {
    margin-left: auto;
    margin-right: 0.25rem;
}
@media (max-width: 991px) {
    .topbar-notif {
        margin-left: 0;
        order: 3;
    }
}

</style>